import { apiClient } from './client'
import type {
  PipelineName,
  PipelineRun,
  PipelineRunDetail,
  PipelineSchedule,
  SchedulerConfigUpdate,
} from '@/types/api'

export const schedulerApi = {
  async getConfig(): Promise<{ schedules: PipelineSchedule[] }> {
    const response = await apiClient.get('/v1/admin/scheduler/config')
    return response.data
  },

  async updateConfig(
    pipeline: PipelineName,
    update: SchedulerConfigUpdate,
  ): Promise<PipelineSchedule> {
    const response = await apiClient.patch(
      `/v1/admin/scheduler/config/${pipeline}`,
      update,
    )
    return response.data
  },

  async listRuns(params?: {
    pipeline?: PipelineName
    status?: string
    limit?: number
    offset?: number
  }): Promise<{ runs: PipelineRun[]; total: number }> {
    const response = await apiClient.get('/v1/admin/scheduler/runs', { params })
    return response.data
  },

  async stopRun(runId: number): Promise<{ status: string; message: string }> {
    const response = await apiClient.post(`/v1/admin/scheduler/runs/${runId}/stop`)
    return response.data
  },

  async getRun(runId: number): Promise<PipelineRunDetail> {
    const response = await apiClient.get(`/v1/admin/scheduler/runs/${runId}`)
    return response.data
  },

  async triggerRun(pipeline: PipelineName): Promise<{ status: string; message: string }> {
    const response = await apiClient.post(
      `/v1/admin/scheduler/runs/${pipeline}/trigger`,
    )
    return response.data
  },

  // Logs come back as text/plain. responseType 'text' stops axios trying to
  // parse them as JSON.
  async downloadRunLog(runId: number): Promise<string> {
    const response = await apiClient.get(`/v1/admin/scheduler/runs/${runId}/log`, {
      responseType: 'text',
    })
    return response.data
  },

  async downloadRangeLog(
    from: string,
    to: string,
    pipeline?: PipelineName,
  ): Promise<string> {
    const response = await apiClient.get('/v1/admin/scheduler/logs', {
      params: { date_from: from, date_to: to, pipeline },
      responseType: 'text',
    })
    return response.data
  },
}
